<!-- Translated: yes -->
<template>
  <div>
    <Modal @close="localCloseModal" :wide="false" width="800px" :show-close="false">

      <h1 v-if="currentPaymentState == 'before-and-during-payment'">{{ $t('general.payment.titles.before-and-during-payment--skirental') }}</h1>
      <h1 v-if="currentPaymentState == 'syncing'">{{ $t('general.payment.titles.syncing') }}</h1>
      <h1 v-if="currentPaymentState == 'error'">{{ $t('general.payment.titles.error') }}</h1>
      <h1 v-if="currentPaymentState == 'error-on-sync'">{{ $t('general.payment.titles.error-on-sync') }}</h1>
      <h1 v-if="currentPaymentState == 'success'">{{ $t('general.payment.titles.success') }}</h1>

      <div ref="handler"></div>

      <h2 class="center" v-if="currentPaymentState == 'before-and-during-payment'">{{ $t('general.payment.to-pay') }}:&nbsp;&nbsp;&nbsp;<b>{{sum | currency}}</b></h2>

      <p v-if="currentPaymentState == 'before-and-during-payment'">&nbsp;</p>

      <div class="info-image center" v-if="currentPaymentState == 'before-and-during-payment'">
        <img src="https://static.booking.branasgruppen.se/static/svg/kortterminal.svg" class="pulsing" />
        <p>{{ $t('general.payment.insert-card-instructions') }}</p>

        <p>&nbsp;</p>
        <p v-if="!canCancel">{{ $t('general.payment.cancel-instructions') }}<br /><br /></p>
        <button class="white border" @click.stop="localCloseModal(true)">{{ $t('general.payment.cancel') }}</button>
      </div>
      <div class="info-image center" v-if="currentPaymentState == 'syncing'">
        <!--<img src="https://static.booking.branasgruppen.se/static/svg/Reset.svg" class="rotating" />-->
        <p>{{ $t('general.payment.syncing') }}</p>

        <CreatingOrder method="chip" :hash="hash" :show-texts="false" :do-redirect="false" @callback="onSyncCallback" />
      </div>
      <div class="info-image center" v-if="currentPaymentState == 'error'">
        <img src="https://static.booking.branasgruppen.se/static/svg/error.svg" />
        <p>{{messages[0].message}}</p>
      </div>
      <div class="info-image center" v-if="currentPaymentState == 'error-on-sync'">
        <img src="https://static.booking.branasgruppen.se/static/svg/error.svg" />
        <p>{{ $t('general.payment.sync-error') }}</p>
      </div>
      <div class="info-image center" v-if="currentPaymentState == 'success'">
        <img src="https://static.booking.branasgruppen.se/static/svg/kortterminal-check.svg" />
        <p>{{ $t('general.payment.synced-remember-reciept') }}</p>
        <p>{{ $t('general.payment.your-order-number') }}:</p>
        <p class="order-number">{{orderNumber}}</p>
        <p class="smaller">{{ $t('general.payment.closing', {seconds: 10}) }}</p>
      </div>

      <div v-if="currentPaymentState === 'error'" class="center">
        <p>&nbsp;</p>
        <button @click.stop="resetPayment()">{{ $t('general.payment.try-again') }}</button>
        <button class="white" @click.stop="cancel()">{{ $t('general.payment.cancel-booking') }}</button>
      </div>

      <div v-if="currentPaymentState === 'error-on-sync'" class="center">
        <p>&nbsp;</p>
        <button @click.stop="createOrder()">{{ $t('general.payment.try-again') }}</button>
      </div>

      <div v-if="false">
        <p v-for="{message} in messages">{{message}}</p>
      </div>

      <!-- <Loading text="" :show="true" style="position:static;" /> -->

    </Modal>
    <div v-if="$store.state.isDebugging" class="debugging">
      Simulera:
      <button class="small white border" @click="simulateTerminalInsert()">Sätt i kort</button>
      <button class="small white border" @click="simulateTerminalCode()">Ange kod</button>
      <button class="small white border" @click="simulateTerminalApprove()">Godkänn</button>
      <button class="small white border" @click="simulateTerminalCancel()">Avbryt</button>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/components/Modal';
import Loading from '@/components/components/Loading';
import Cart from '@/components/parts/Cart';
import CreatingOrder from '@/components/parts/CreatingOrder';

import API from '@/classes/API';

import moment from 'moment';
import { mapMutations } from 'vuex';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Cart,
    Loading,
    CreatingOrder,
  },
  data() {
    return {
      messages: [],
      showOk: false,
      showCancel: false,
      canCancel: false,
      hash: '',
      currentPaymentState: 'before-and-during-payment',
      orderNumber: '',
      eventNumber: 0,
      logs: [],
      loggerTimer: null,
    };
  },
  mounted() {
    this.log('mounted');
    this.log('aftermounted');
  },
  created() {
    this.log('created');
    if (!this.params.confirmationOnly) {
      this.loggerTimer = setInterval(this.sendLogs, 2000);

      document.addEventListener('terminaltexts', this.handleTerminalTexts);
      document.addEventListener('paysuccess', this.handlePaySuccess);
      document.addEventListener('payfail', this.handlePayFail);
      document.addEventListener('paytransactionstarted', this.handlePayStarted);

      this.$nextTick(() => {
        this.log('outer starting payment');
        this.startPayment();
        this.log('outer started payment');
      });
    } else {
      this.onSyncCallback(this.params.orderNumber);
    }
    this.log('aftercreated');
  },
  destroyed() {
    this.log('destroy');
    if (!this.params.confirmationOnly) {
      clearInterval(this.loggerTimer);
      document.removeEventListener('terminaltexts', this.handleTerminalTexts);
      document.removeEventListener('paysuccess', this.handlePaySuccess);
      document.removeEventListener('payfail', this.handlePayFail);
      document.removeEventListener('paytransactionstarted', this.handlePayStarted);
    }
    this.log('destroyed');
  },
  computed: {
    sum() {
      if (this.$store.state.isDebugging) {
        return 1;
      }

      const rentals = this.$store.state.cart.rentals.reduce((a, b) => {
        if (b.confirmed) {
          const insurance = (b.insurance ? (b.insuranceSum || 0) : 0);
          return a + (b.price * parseInt(b.quantity, 10)) + insurance;
        }
        return a;
      }, 0);

      const schools = this.$store.state.cart.skischools.reduce((a, b) =>
        (b.confirmed ? a + (b.price * parseInt(b.quantity, 10)) : a), 0,
      );
      const passes = this.$store.state.cart.skipasses.reduce((a, b) =>
        (b.confirmed ? a + (b.price * parseInt(b.quantity, 10)) : a), 0,
      );

      return rentals + schools + passes;
    },
    tax() {
      return this.sum * 0.20;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'clearCart',
    ]),
    resetPayment() {
      this.log('resetting payment');
      this.startPayment();
      this.log('reset payment');
    },
    cancel() {
      this.log('cancelling');
      const $this = this;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.cancel-booking-question-title'),
        content: this.$i18n.t('general.cancel-booking-question-text'),
        yes: () => {
          $this.closeAllModals();
          $this.clearCart();
          $this.$router.replace({
            path: '/pa-plats',
            query: {
              site: $this.$store.state.isOnWhichSite,
              refresh: 1,
            },
          });
        },
        no: () => {
          $this.closeAllModals();
        },
      }]);
    },
    cancelWithoutConfirmation() {
      this.log('closing modal without confirmation');
      this.closeAllModals();
      this.clearCart();
      this.$router.replace({
        path: '/pa-plats',
        query: {
          site: this.$store.state.isOnWhichSite,
          refresh: 1,
        },
      });
    },
    startPayment() {
      this.log('starting payment');
      const evt = document.createEvent('CustomEvent');
      const obj = {
        amount: this.sum * 100,
        vat: this.tax * 100,
        refund: 0,
      };
      this.log('payment object', obj);
      evt.initCustomEvent('pay', true, true, obj);
      this.log('event', 'pay', obj);
      this.$refs.handler.dispatchEvent(evt);
      this.currentPaymentState = 'before-and-during-payment';
      this.syncPayDialog(false, false, '', '', '', '');
      this.canCancel = true;
      this.log('started payment');
    },
    syncPayDialog(ok, cancel, row1, row2, row3, row4) {
      this.showOk = ok;
      this.showCancel = cancel;
      this.messages = [];
      this.messages.push({ message: row1 });
      this.messages.push({ message: row2 });
      this.messages.push({ message: row3 });
      this.messages.push({ message: row4 });
      this.canCancel = false;
    },
    handleTerminalTexts(e) {
      this.log('recieving terminal text');
      const obj = e.detail;
      this.log('recieved terminal text', obj);
      let cancelButton;
      let okButton;
      if (obj.row2 && obj.row2.indexOf('KÖP GODKÄNT') > -1) {
        cancelButton = false;
      }
      this.syncPayDialog(okButton, cancelButton, obj.row1, obj.row2, obj.row3, obj.row4);
      this.log('synced pay dialog');
    },
    handlePaySuccess(e) {
      this.log('handle pay success');
      const obj = e.detail;
      this.log('recieved handle pay success', obj);
      this.hash = obj.hash;
      this.syncPayDialog(false, false, this.$i18n.t('skirental.payment-recieved-take-reciept'), '', '', '');
      this.log('synced pay dialog');
      this.createOrder();
      this.log('created order');
      this.log('sent payment ga-event');
    },
    createOrder() {
      this.currentPaymentState = 'syncing';
    },
    onSyncCallback(orderNumber) {
      this.log('sync callback');
      if (orderNumber) {
        this.currentPaymentState = 'success';
        this.orderNumber = orderNumber;
        this.printBookingNumber(orderNumber);
        setTimeout(this.cancelWithoutConfirmation, 10000);
      } else {
        this.currentPaymentState = 'error-on-sync';
      }
      this.log('sync callback end');
    },
    handlePayFail(e) {
      this.log('handle pay fail');
      this.currentPaymentState = 'error';
      const obj = e.detail;
      this.log('recieved handle pay fail', obj);
      const message2 = obj.message;
      let message;

      switch (obj.reason) {
        case 1:
          message = this.$i18n.t('skirental.payment.errors.1');
          break;
        case 2:
          message = this.$i18n.t('skirental.payment.errors.2');
          break;
        case 3:
          message = this.$i18n.t('skirental.payment.errors.3');
          break;
        case 4:
          message = this.$i18n.t('skirental.payment.errors.4');
          break;
        case 5:
          message = this.$i18n.t('skirental.payment.errors.5');
          break;
        case 6:
          message = this.$i18n.t('skirental.payment.errors.6');
          break;
        case 7:
          message = this.$i18n.t('skirental.payment.errors.7');
          break;
        default:
          message = this.$i18n.t('skirental.payment.errors.default');
      }

      this.syncPayDialog(false, false, message, message2, '', '');
      this.log('synced pay fail dialog');
      this.log('sent payment fail ga-event');
    },
    handlePayStarted(e) {
      const obj = e.detail;
      this.log('payment started with', obj);
    },
    printBookingNumber(number) {
      if (this.SITE_CONFIG.site === 'vallasen' || this.SITE_CONFIG.site === 'ulricehamn') {
        this.log('printing booking number');
        const evt = document.createEvent('CustomEvent');
        const date = moment().format('YYYY-MM-DD HH:mm:ss');
        const textBookingNumber = this.$i18n.t('general.bookingnumber');
        const siteName = this.SITE_CONFIG.site_name;
        const textDate = this.$i18n.t('general.date');
        const textSkirental = this.$i18n.t('general.skirental');

        const obj = {
          title: `${textBookingNumber} ${number}`,
          text: `\n\n${siteName} ${textSkirental}\n\n\n${textBookingNumber}:  ${number}\n\n${textDate}:           ${date}\n\n\n\n\n`,
          includeCutCommand: true,
        };

        this.log('printing booking number with', obj);

        evt.initCustomEvent('print', true, true, obj);

        this.log('printed booking number');
        document.dispatchEvent(evt);
      }
    },
    simulateTerminalInsert() {
      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('terminaltexts', true, true, { row1: 'A', row2: 'B', row3: 'C', row4: 'D' });
      document.dispatchEvent(evt);
    },
    simulateTerminalCode() {
      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('terminaltexts', true, true, { row1: 'A', row2: 'B', row3: 'C', row4: 'D' });
      document.dispatchEvent(evt);
    },
    simulateTerminalApprove() {
      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('paysuccess', true, true, { hash: 'manual' });
      document.dispatchEvent(evt);
    },
    simulateTerminalCancel() {
      const evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('payfail', true, true, { reason: 1, message: 'hej, det blev fel' });
      document.dispatchEvent(evt);
    },
    localCloseModal(force) {
      this.log('closing modal');
      if (force === true) {
        this.log('force closing modals');
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent('cancelpay', true, true, { });
        this.log('sent closing event');
        document.dispatchEvent(evt);
        this.closeModal();
      }
      this.log('closed modal');
    },
    log(...args) {
      this.eventNumber += 1;
      console.log(this.eventNumber, args, this.$store.state.user_code);
      this.logs.push({
        part: 'pay-on-site',
        user: this.$store.state.user_code,
        iterator: this.eventNumber,
        data: JSON.stringify(args),
      });
    },
    sendLogs() {
      if (this.SITE_CONFIG.rental.onsite_frontend_logger && this.logs.length) {
        const logs = Object.assign({}, this.logs);
        this.logs = [];
        API.frontendHelper('/log', {
          logs,
          cart: this.$store.state.cart,
        });
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

.uppercase
  uppercase()

.box
  border-radius 3px
  background-color #ffffff
  border solid 1px #c2dbe2
  padding space-2
  margin-bottom 20px

.places
  display: flex
  uppercase()
  font-size 13px
  & > *
    margin-right 25px

.insurance
  border-radius 2px
  background-color rgba(236, 245, 248, 0.5)
  border solid 1px #bfd9e1
  padding space-3
  p
    font-size: 13px
    font-weight: 300
  .checkbox-wrapper
    margin-right: 15px

h3
  font-family Interstate
  font-size 14px
  font-weight bold
  color #262626
  em, i
    font-style: normal;
    display: inline-block;
    margin-left 15px
.price
  font-family Interstate
  font-size 21px
  font-weight bold
  color #262626
.info-image
  width 330px
  img
    margin-bottom 25px
    width 50%
    &.pulsing
      animation: pulsingimage 3s infinite;
    &.rotating
      width 35%
      animation: rotatingimage 2s infinite linear;

.debugging
  position: fixed;
  background-color lightgreen
  bottom 10px
  left 0
  width 100%
  height auto
  color black
  font-size 8px
  uppercase()
  z-index 100001
  text-align center
  line-height 10px
  padding 2px
.order-number
  font-size 36px
  font-weight: 600
.smaller
  font-size 11px
  font-style: italic;
  color #999999
</style>
<style scoped>
@keyframes rotatingimage {
  0%   {transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
}
@keyframes pulsingimage {
  0%   {transform: scale(0.95); }
  50% { transform: scale(1.05); }
  100% { transform: scale(0.95); }
}
</style>



// WEBPACK FOOTER //
// OnSitePayment.vue?66110f1b